import React, {useEffect, useState} from 'react';
import styles from './TourCur.module.css';
import TourCurForm from "../TourCurForm/TourCurForm";
import {fetchTournaments, fetchFriendlyTournaments} from "../../api/api";
import Spinner from "../Spinner/Spinner";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import UnrankedTournamentsSection from "../UnrankedTournaments/UnrankedTournamentsSection";

const TourCur = ({ initialTournamentId }) => {
    const [tournaments, setTournaments] = useState([]);
    const [selectedTournament, setSelectedTournament] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    // Turnieje towarzyskie nie trafiają na główną listę (/tournaments je odfiltrowuje),
    // ale po wystartowaniu pokazujemy je jawnie w sekcji „Nierankingowe".
    // Zapisy pozostają wyłącznie z linku tokenowego — endpoint nie wydaje PLANNED.
    const [friendlyTournaments, setFriendlyTournaments] = useState([]);

    useEffect(() => {
        const fetchActiveTournaments = async () => {
            try {
                const result = await fetchTournaments('ACTIVE');
                if (result.success) {
                    const sortedTournaments = result.data.sort((a, b) => {
                        return new Date(b.tournamentDate) - new Date(a.tournamentDate);
                    });
                    setTournaments(sortedTournaments);
                    if (initialTournamentId) {
                        const found = sortedTournaments.find(t => t.id === initialTournamentId);
                        if (found) setSelectedTournament(found);
                    }
                    setIsLoading(false)
                }
            } catch (error) {
                console.error("Failed to fetch active tournaments", error);
                setError("Błąd pobrania danych");
                setIsLoading(false);
            }
        };

        fetchActiveTournaments();
    }, [initialTournamentId]);

    useEffect(() => {
        // Błąd pobrania zostawia pustą listę — sekcja po prostu się nie pokaże,
        // a główna lista turniejów działa dalej.
        const loadFriendly = async () => {
            const result = await fetchFriendlyTournaments('ACTIVE');
            setFriendlyTournaments(result.success ? result.data : []);
        };
        loadFriendly();
    }, []);

    const handleReturnToList = () => {
        setSelectedTournament(null);
    };

    if (isLoading) return <Spinner size={"large"}/>;
    if (error) return <ErrorMessage error={error}/>;

    return (
        <div>
            {selectedTournament && <TourCurForm tournament={selectedTournament} isArchived={false} onReturn={handleReturnToList}/>}
            <div className={styles.tournaments}>
                {!selectedTournament && tournaments.length > 0 ? (
                    tournaments.map((tournament) => (
                        <button
                            key={tournament.id}
                            className={styles.tournamentButton}
                            onClick={() => setSelectedTournament(tournament)}
                        >
                            {`${tournament.title}`}
                        </button>
                    ))
                ) : (
                    !selectedTournament && <p className={styles.noTournamentsMessage}>Brak trwających turniejów.</p>
                )}
            </div>

            {!selectedTournament && (
                <UnrankedTournamentsSection
                    tournaments={friendlyTournaments}
                    onSelect={setSelectedTournament}
                />
            )}
        </div>
    );
};

export default TourCur;
